const PencilEditIcon = (props: any) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="28"
        viewBox="0 0 26 28"
        fill="none"
        {...props}
    >
        <path
            d="M3.27548 24.375H5.20327L17.0799 11.4375L15.1521 9.3375L3.27548 22.275V24.375ZM22.9665 9.2625L17.1143 2.9625L19.0421 0.8625C19.5699 0.2875 20.2183 0 20.9871 0C21.7559 0 22.4042 0.2875 22.9321 0.8625L24.8599 2.9625C25.3877 3.5375 25.6631 4.23125 25.6861 5.04375C25.709 5.85625 25.4566 6.55 24.9287 7.125L22.9665 9.2625ZM20.9699 11.475L6.37372 27.375H0.521484V21L15.1176 5.1L20.9699 11.475Z"
            fill="current"
        />
    </svg>
);

export default PencilEditIcon;
